import { ReactNode } from "react"

import { CollapseIcon } from "components/CollapseIcon"
import { useToggle } from "ui-kit/components-branded/hooks/useToggle"

export const Accordion = (props: {
    collapsed?: boolean
    header?: ReactNode
    preview?: ReactNode
    children?: ReactNode
}) => {
    const [collapsed, toggleCollapsed] = useToggle(props.collapsed)
    return (
        <>
            <div className="is-flex accordion__header" onClick={toggleCollapsed}>
                <div className="is-flex-grow-1">{props.header}</div>
                <div>
                    <CollapseIcon collapsed={collapsed} />
                </div>
            </div>
            {collapsed ? props.preview : props.children}
        </>
    )
}
